// Endereços antigos da Central (`/v2/ai-center?tab=social&item_id=5`) viram as
// rotas próprias do redesign (`/v2/ai-center/comentarios/5`). Função pura: a
// rota `ai_center` chama no beforeEnter e a página de entrada chama de novo
// quando as features da conta chegam (sem elas não dá para escolher a
// primeira área ligada).
import { areaById, firstVisibleArea } from './aiCenterAreas';

// Filtros da lista antiga que a área nova recebe na query. `page` cai: a
// paginação nova não usa o mesmo número. `from_world` segue para a barra de
// voltar saber de onde a pessoa veio. Os `report_*` são de Reports da IA, que
// entra na casca nova com a mesma tela: filtro, página e report aberto ficam
// no link compartilhado.
export const LEGACY_FORWARDED_QUERY = [
  'status',
  'source',
  'funnel_id',
  'from',
  'to',
  'provider',
  'from_world',
  'report_status',
  'report_source',
  'report_category',
  'report_page',
  'report_id',
];

const firstValue = value => (Array.isArray(value) ? value[0] : value);

const forwardedQuery = query =>
  Object.fromEntries(
    LEGACY_FORWARDED_QUERY.map(key => [key, firstValue(query[key])]).filter(
      ([, value]) => value !== undefined && value !== null && value !== ''
    )
  );

// `isEnabled` e `isAdmin`: só para quem chega sem `tab` (primeira área ligada).
// Devolve null quando não há o que resolver ainda.
export const resolveLegacyAiCenter = (
  to,
  { isEnabled = null, isAdmin = false } = {}
) => {
  const query = to?.query || {};
  const params = { accountId: to?.params?.accountId };
  const tab = firstValue(query.tab);

  const area = areaById(tab);
  const kept = forwardedQuery(query);
  if (area) {
    const itemId = String(firstValue(query.item_id) ?? '');
    if (/^\d+$/.test(itemId)) {
      return {
        name: 'ai_center_item',
        params: { ...params, area: area.slug, itemId },
        query: kept,
      };
    }
    return {
      name: 'ai_center_area',
      params: { ...params, area: area.slug },
      query: kept,
    };
  }

  if (typeof isEnabled !== 'function') return null;
  const first = firstVisibleArea({ isEnabled, isAdmin });
  if (!first) return null;
  return {
    name: 'ai_center_area',
    params: { ...params, area: first.slug },
    query: kept,
  };
};
